import { ModelID, SearchParams } from '@/types';
import { ReferralCampaign } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'referral-campaign_id';
export interface ReferralCampaignSearchParams
  extends SearchParams<Filter, Sort>,
    Partial<ReferralCampaign> {}

export const featurePath = '/v4/locations/referral-campaign';

export const featureKeys = {
  all: [{ scope: 'referral-campaigns' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: ReferralCampaignSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
